// frontend/src/hooks/useTaleImages.ts

import { useEffect, useState } from 'react';

export function useTaleImages(taleId: string) {
  const [items, setItems] = useState<{id:string; url:string|null; title?:string; idx?:number; type?:string}[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        
        // 1) Load working thumbnails as background options (baked PNGs)
        const thumbnailsRes = await fetch(`/api/thumbnails/tale/${encodeURIComponent(taleId)}`, { credentials: 'include' });
        const thumbnailsJson = await thumbnailsRes.json();
        
        const thumbnailImages = [];
        if (thumbnailsJson?.ok && thumbnailsJson?.items?.length > 0) {
          thumbnailImages.push(...thumbnailsJson.items
            .filter((item: any) => item.status === 'generated' && item.r2_key_png)
            .map((item: any, index: number) => ({
              id: item.id,
              url: `/api/thumbnails/${item.id}/png?v=${Date.now()}`,
              title: `Thumbnail ${index + 1}`,
              idx: index + 1,
              type: 'thumbnail'
            })));
          
          console.log('Loaded working thumbnails as backgrounds:', thumbnailImages.length, thumbnailImages);
        }

        // 2) ALSO load generated images that can be used as backgrounds
        const imagesRes = await fetch(`/api/images/${encodeURIComponent(taleId)}?type=all`, { credentials: 'include' });
        const imagesJson = await imagesRes.json();
        const sceneBackgrounds = (imagesJson?.items || [])
          .filter((it: any) => it.status === 'generated' && (it.r2Key || it.id)) // any generated image with a file
          .map((it: any, i: number) => ({
            id: it.id,
            url: `/api/images/file/${it.id}?v=${Date.now()}`,
            title: `AI Background ${it.frameNo || i + 1}`,
            idx: (it.frameNo || i + 1),
            type: 'background'
          }));

        if (alive) {
          // merge, de-dup by id with backgrounds first
          const byId = new Map<string, any>();
          for (const x of [...sceneBackgrounds, ...thumbnailImages]) byId.set(x.id, x);
          setItems(Array.from(byId.values()));
          console.log('Loaded AI background images:', sceneBackgrounds.length, 'thumbnails:', thumbnailImages.length, 'total:', byId.size);
        }
        
      } catch (err) {
        console.error('Failed to load background images:', err);
        if (alive) setItems([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [taleId]);

  return { items, loading };
}
